/**
 * Dependency GraphQL Mutations
 *
 * 7 mutations for dependency lifecycle and DAG management
 */

import { gql } from '@apollo/client';
import { DEPENDENCY_FIELDS_FRAGMENT } from './fragments';

export const CREATE_DEPENDENCY = gql`
  ${DEPENDENCY_FIELDS_FRAGMENT}
  mutation CreateDependency($tenantId: String!, $input: CreateDependencyInput!) {
    createDependency(tenantId: $tenantId, input: $input) {
      ...DependencyFields
    }
  }
`;

export const UPDATE_DEPENDENCY = gql`
  ${DEPENDENCY_FIELDS_FRAGMENT}
  mutation UpdateDependency(
    $tenantId: String!
    $dependencyId: String!
    $input: UpdateDependencyInput!
  ) {
    updateDependency(
      tenantId: $tenantId
      dependencyId: $dependencyId
      input: $input
    ) {
      ...DependencyFields
    }
  }
`;

export const DELETE_DEPENDENCY = gql`
  mutation DeleteDependency($tenantId: String!, $dependencyId: String!) {
    deleteDependency(tenantId: $tenantId, dependencyId: $dependencyId)
  }
`;

export const ADD_DEPENDENCIES_BATCH = gql`
  mutation AddDependenciesBatch(
    $tenantId: String!
    $inputs: [CreateDependencyInput!]!
  ) {
    addDependenciesBatch(tenantId: $tenantId, inputs: $inputs) {
      successful
      failed
      errors
    }
  }
`;

export const UPDATE_DEPENDENCY_STATUS = gql`
  ${DEPENDENCY_FIELDS_FRAGMENT}
  mutation UpdateDependencyStatus(
    $tenantId: String!
    $dependencyId: String!
    $status: DependencyStatus!
  ) {
    updateDependencyStatus(
      tenantId: $tenantId
      dependencyId: $dependencyId
      status: $status
    ) {
      ...DependencyFields
    }
  }
`;

export const BYPASS_DEPENDENCY = gql`
  ${DEPENDENCY_FIELDS_FRAGMENT}
  mutation BypassDependency(
    $tenantId: String!
    $dependencyId: String!
    $reason: String!
  ) {
    bypassDependency(
      tenantId: $tenantId
      dependencyId: $dependencyId
      reason: $reason
    ) {
      ...DependencyFields
    }
  }
`;

export const REBUILD_WORKFLOW_DAG = gql`
  mutation RebuildWorkflowDag($workflowId: String!) {
    rebuildWorkflowDag(workflowId: $workflowId) {
      workflowId
      nodes
      edges {
        from
        to
        type
      }
      isValid
      validationErrors
    }
  }
`;

